<template>
  <v-container fluid class="withoutPadding">
    <v-row class="footerBackground">
      <v-col cols="12" class="introSection">
        <v-row class="d-flex justify-center withoutMargin">
          <v-col cols="12" md="3" lg="2" class="d-flex justify-center">
            <img src="../static/img/logo_aimm_color.png" width="60px" height="20px" />
            <span v-if="!english" class="subtitle">姻緣工程</span>
            <img class="d-none d-md-flex ml-auto" src="../assets/img/line.svg" height="20px" />
          </v-col>
          <v-col cols="12" md="3" lg="2" class="d-flex justify-center">
            <div class="mobileCenter">
              <p class="title">{{ $t('footer.legal') }}</p>
              <div class="content">
                <p class="content-p" @click="goTerm">{{ $t('footer.privacy') }}</p>
                <p class="content-p" @click="goAgreement">{{ $t('footer.agreement') }}</p>
              </div>
            </div>
            <img class="d-none d-md-flex ml-auto" src="../assets/img/line.svg" height="20px" />
          </v-col>
          <v-col cols="12" md="3" lg="2" class="d-flex justify-center">
            <div class="mobileCenter">
              <p class="title">{{ $t('footer.more') }}</p>
              <div class="content">
                <p id="AimmApp" class="content-p">
                  <a id="AimmApp" href="https://app.aimatchmaker.com" target="_blank">Aimm App</a>
                </p>
                <p id="facebookWord" class="content-p">
                  <a
                    id="facebookWord"
                    href="https://www.facebook.com/thisistilaine"
                    target="_blank"
                  >{{ $t('footer.facebook') }}</a>
                </p>
                <p id="youtubeWord" class="content-p">
                  <a
                    id="youtubeWord"
                    href="https://www.youtube.com/channel/UCV8NgaE7fVjD73NfBIWY5qA"
                    target="_blank"
                  >Youtube</a>
                </p>
              </div>
            </div>
            <img class="d-none d-md-flex ml-auto" src="../assets/img/line.svg" height="20px" />
          </v-col>
          <v-col cols="12" md="3" lg="2" class="d-flex justify-center">
            <div class="mobileCenter">
              <p class="title">{{ $t('footer.contact_us') }}</p>
              <div class="content">
                <p class="content-p">+886.2.7704.6678</p>
                <p class="content-p">service@aimatchmaker.com</p>
                <p class="content-p">{{ $t('footer.partnership') }}</p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="copyrightSection">
        <v-row class="d-flex justify-center">
          <v-btn id="instaIcon" icon style="margin-right: 15px" class>
            <img src="../assets/img/icon_insta.svg" width="30px" @click="toIg" />
          </v-btn>
          <v-btn id="fbIcon" icon style="margin-right: 15px" class>
            <img src="../assets/img/icon_fb.svg" width="30px" @click="toFb" />
          </v-btn>
          <v-btn id="ytIcon" icon style="margin-right: 15px" class>
            <img src="../assets/img/icon_yt.svg" width="30px" @click="toYt" />
          </v-btn>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-col cols="10" md="5" lg="4" class="d-flex justify-center">
            <span class="copyright mobileCenter">{{ $t('footer.copyright') }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      english: false,
    };
  },
  computed: {
    ...mapGetters("globalVar", {
      language: "getLanguage",
    }),
  },
  watch: {
    language() {
      this.english = this.language === "en";
    },
  },
  mounted() {
    this.english = this.language === "en";
  },
  methods: {
    toIg() {
      window.open("https://www.instagram.com/this_is_tilaine/");
    },
    toFb() {
      window.open("https://www.facebook.com/thisistilaine");
    },
    toYt() {
      window.open("https://www.youtube.com/channel/UCV8NgaE7fVjD73NfBIWY5qA");
    },
    goTerm() {
      this.$router.push({ path: "/term" });
      setTimeout(() => {
        let element = document.querySelector("#termPage");
        window.scrollTo({
          top: window.pageYOffset + element.getBoundingClientRect().top + 10,
          behavior: "smooth",
        });
        // TODO: 追蹤ga
      }, 150);
    },
    goAgreement() {
      this.$router.push({ path: "/agreement" });
      setTimeout(() => {
        let element = document.querySelector("#agreementPage");
        window.scrollTo({
          top: window.pageYOffset + element.getBoundingClientRect().top + 10,
          behavior: "smooth",
        });
        // TODO: 追蹤ga
      }, 150);
    },
  },
};
</script>
<style scoped lang="scss">
.withoutMargin {
  margin: 0;
}
.sectionBackground {
  margin: 0;
  background-color: #e1dfda;
  min-height: 150px;
}
.withoutPadding {
  padding: 0;
  &.relative {
    position: relative;
  }
}
.background {
  margin: 0;
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #e2dfda;
}
.footerBackground {
  position: relative;
  min-height: 389px;
  margin: 0;
  background: #eeecea;
  .footerImage {
    position: relative;
  }
}
.media-side {
  flex: 0 1 auto;
  width: 95%;
  max-width: 1330px;
  img {
    width: 150px;
  }
  .media-row {
    margin: 25px -15px;
  }
  .mobile-media {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
    img {
      width: 80%;
    }
  }
}
.story-side {
  position: absolute;
  top: -125px;
  z-index: 2;
  width: 95%;
  background-color: #eeecea;
  max-width: 680px;
  height: 192px;
  box-shadow: 0 31px 101px 0 rgba(0, 0, 0, 0.19);
  border: solid 6px #ffffff;
  border-radius: 36px;
  overflow: hidden;
  .footer-img {
    padding: 0 !important;
    // height: 192px;
    background-size: cover;
    background-position: center center;
    overflow: hidden;
    background-image: url("../static/img/footer-img.png");
  }
  .icon-side {
    padding: 0;
    margin-left: 20px;
    margin-top: 7px;
  }
  .mobile-story {
    margin-top: 30px;
  }
  .mobile-text {
    padding-top: 0;
  }
  .writing {
    margin-top: 24px;
    -webkit-writing-mode: vertical-lr;
    writing-mode: vertical-lr;
    font-size: 14px;
    font-family: "Roboto", sans-serif !important;
  }
  .span-hr {
    margin-top: 37.5px;
    margin-bottom: 37.5px;
    display: inline-block;
    width: 40px;
    height: 1px;
    border-top: 1px solid;
  }
  .story-text {
    font-size: 16px;
    font-weight: 300;
    color: #000;
  }
  .story-sign {
    margin-top: 55px;
    p {
      font-weight: bold;
      font-size: 12px;
    }
    img {
      width: 160px;
      margin-top: 27px;
    }
    .profile {
      font-size: 11px;
      font-weight: normal;
      margin-top: 45px;
    }
    .english-profile {
      margin-top: 30px;
    }
  }
}
.pinkCircle {
  position: absolute;
  top: -80px;
  bottom: 87px;
  width: 287px;
  height: 287px;
  border-radius: 50%;
  background-image: linear-gradient(180deg, #f3698a 0%, #c83659 100%);
  .circleContent {
    height: inherit;
    .content {
      position: absolute;
      top: 40%;
      left: 25%;
      font-size: 30px;
      font-weight: bold;
      font-family: "Noto Sans TC", sans-serif !important;
      color: white;
    }
  }
}
.blueCircle {
  position: absolute;
  top: 110px;
  left: 250px;
  width: 149px;
  height: 149px;
  border-radius: 50%;
  background-image: linear-gradient(180deg, #464ee1 0%, #0b2870 97%);
}
.introSection {
  margin-top: 90px;
  .subtitle {
    margin-left: 15px;
    font-size: 16px;
    font-weight: 400;
    font-family: "Noto Sans TC", sans-serif !important;
  }
  .title {
    font-size: 16px !important;
    font-weight: bold !important;
    font-family: "Noto Sans TC", sans-serif !important;
  }
  .content {
    cursor: pointer;
    color: #030303;
    font-size: 12px;
    font-weight: 550;
    font-family: "Noto Sans TC", sans-serif !important;
    .content-p {
      margin-bottom: 5px;
    }
  }
  a {
    color: #030303;
    text-decoration: none;
  }
}
.copyrightSection {
  max-height: 120px;
}
.copyright {
  font-size: 12px;
  font-weight: bold;
  font-family: "Noto Sans TC", sans-serif !important;
}
@media screen and (min-width: 960px) and (max-width: 1264px) {
  .media-side {
    img {
      width: 100px;
    }
  }
  .introSection {
    margin-top: 90px;
    .subtitle {
      margin-left: 12px;
      font-size: 16px;
      font-weight: bold;
      font-family: "Noto Sans TC", sans-serif !important;
    }
    .title {
      font-size: 16px !important;
      font-weight: bold !important;
      font-family: "Noto Sans TC", sans-serif !important;
    }
    .content {
      font-size: 12px;
      font-weight: 550;
      font-family: "Noto Sans TC", sans-serif !important;
    }
  }
}
@media screen and (max-width: 960px) {
  .mobileCenter {
    text-align: center;
  }
}
</style>
